import { render } from "./DetailsTab.vue?vue&type=template&id=78e9b56c"
import script from "./DetailsTab.vue?vue&type=script&lang=js"
export * from "./DetailsTab.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__